import styled, { keyframes } from 'styled-components';

import Modal from 'components/modal';

const slideIn = keyframes`
  from {
    transform: translate(-50%,-60%);
  } to {
    transform: translate(-50%,-50%);
    opacity: 1
  }
`;

export const StyledModal = styled(Modal)`
  ${Styles.desktop`
    opacity: 0;
    animation: ${slideIn} 0.5s 0.3s forwards;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  height: 23rem;
  width: 21rem;
  overflow: hidden;
`;

export const Title = styled.p`
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.heavy};
  margin: 0;
  line-height: 1.9rem;
`;

export const Address = styled.h1`
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.normal};
  font-size: 2rem;
  font-family: ${Styles.fontFamily.brand};
  margin: 0;
  line-height: 1.8rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
`;

export const H2 = styled.p`
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const P = styled.p`
  margin: 0;
`;

export const Details = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
  p:first-of-type {
    margin-right: 15px;
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 13rem;
  margin: 1rem 0;
  border-radius: ${Styles.borderRadius};
  overflow: hidden;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
